module.exports = __webpack_public_path__ + "img/BusinessOutlined.4a809fa0.svg";